<template>
	<page-body>
		<!--工具条-->
		<el-row :gutter="20">
		  	<el-col :span="4">
				<el-input v-model="batchNo" placeholder="请输入批号" @keyup.enter="myonkeyup" @change="getWarehouses" icon="search"></el-input>
		  	</el-col>
		  	<el-col :span="14">
					<el-select multiple  style='margin-bottom:20px;width:100%'  v-model="name" filterable="" clearable remote placeholder="请输入商品名称" :remote-method="remoteMethod" >
	            		<el-option v-for="item in items" :key="item.key" :label="item.label" :value="item.key">
	          			</el-option>
	        		</el-select>
		 	</el-col>

			<el-col :span="2">
		 	<el-button style='float:right' type="primary" icon="search" @click="getWarehouses()"></el-button>
		 	</el-col>
		 	<el-col :span="2">
		 	<el-button style='float:left' type="primary" icon="document" @click="handleDownload">导出excel</el-button>
		 	</el-col>
		</el-row>

		<!--列表-->
		<el-table :data="warehouses" border stripe :search-def='getSearchDef()' highlight-current-row v-loading="listLoading" @selection-change="selsChange" @row-dblclick="rowDblclick" style="width: 100%;">
			<el-table-column type="index" width="60">
			</el-table-column>
			<el-table-column prop="itemNo" label="商品编号" width="100">
			</el-table-column>
			<el-table-column prop="itemName" label="商品名称" min-width="180" sortable>
			</el-table-column>
			<el-table-column prop="spec" label="商品规格" min-width="120" sortable>
			</el-table-column>
			<el-table-column prop="manufacture" label="生产厂家" min-width="210" sortable>
			</el-table-column>
			<el-table-column prop="unit" label="单位" width="70">
			</el-table-column>
			<el-table-column prop="unitQty" label="包装数量" width="100">
			</el-table-column>
			<el-table-column prop="batchNo" label="批号" width="120" sortable>
			</el-table-column>
			<el-table-column prop="warehouseQty" label="库存数量" width="120" sortable>
			</el-table-column>
			<el-table-column prop="status" label="库存状态" width="100">
			</el-table-column>
			<el-table-column prop="productionDate" label="生产日期" width="120" sortable>
			</el-table-column>
			<el-table-column prop="expiryDate"   label="失效日期" width="120"  sortable>
			</el-table-column>
			<el-table-column prop="stockDate"   label="库存日期" width="120"  sortable>
			</el-table-column>
       <el-table-column prop="department" label="部门" width="100" >
      </el-table-column>

		</el-table>
			<!--工具条-->
		<el-col :span="24" class="toolbar">

			<el-pagination style="float:right;"
		      @size-change="handleSizeChange"
		      @current-change="handleCurrentChange"
		      :current-page="page"
		      :page-sizes="[5, 10, 15, 20]"
		      :page-size="pageSize"
		      layout="total, sizes, prev, pager, next, jumper"
		      :total="total">
		    </el-pagination>
		</el-col>

	</page-body>

</template>

<script>
	//import NProgress from 'nprogress'
	import { webapi, HTTP} from '../../api/api';
	import util from '../../common/js/util';
	import { export_json_to_excel } from '../../vendor/Export2Excel';
	export default {
		data() {
			return {
				batchNo: '',
				name: [],
				pageSize:15,
				warehouses: [],
				items:[],
				total: 0,
				page: 1,
				listLoading: false,
				sels: []//列表选中列

			}
		},
		methods: {
			handleDownload() {
		      var vm = this;
				let para = {
				};
				if(vm.batchNo){
					para.batchNo = vm.batchNo
				}
				var uploadName = '';
				for(var i = 0; i <vm.name.length; i++){
					uploadName+= vm.name[i]+','
				}
				para.name =uploadName;
				webapi.post('/warehouse/findAll', para)
				  .then(function(response) {
				  	require.ensure([], () => {
			        const tHeader = ['序号', '商品编号', '商品名称', '商品规格', '生产厂家','单位','包装数量','批号','库存数量','库存状态','生产日期','失效日期','库存日期'];
			        const filterVal = ["id","itemNo","itemName","spec","manufacture","unit","unitQty","batchNo","warehouseQty","status","productionDate","expiryDate","stockDate"];
			        const list = response.data;
			        const data = vm.formatJson(filterVal, list);
			        export_json_to_excel(tHeader, data, '库存数据表');
			      })
				 }).catch((error) => {
				    vm.$message.error(error.response.data['message']);
				});

		    },
		    formatJson(filterVal, jsonData) {
		      return jsonData.map(v => filterVal.map(j => v[j]))
		    },
			remoteMethod(query) {
	          	var vm = this;
	            let para = {
                params:{
                  offset: (vm.page-1)*vm.pageSize,
                  max: 500,
                  "queryParams": query,
                  "query":"itemName"
                }
              };
	            webapi.get('/item', para)
	            .then(function(response) {
	               //console.log(response.data.results)
	               vm.list = response.data.map(item => {
	                        return {key:item.id,value:item.itemName, label:item.itemNo+" "+item.itemName+" "+item.spec};
	                      });

	              vm.loading = false;
	              vm.items = vm.list
	            }).catch((error) => {
	            	vm.loading = false;
				    vm.$message.error(error.response.data['message']);
				});

        },
			// formatter: function (row, column) {
	  //     		return util.formatDate.format(row.salesDate, 'yyyy-MM-dd');
			// },
			handleSizeChange(val) {

				this.pageSize = val
				this.getWarehouses();
				// this.getBranchWarehouse();
	        	// console.log(`每页 ${val} 条`);
	      	},
			handleCurrentChange(val) {
				this.page = val;
				this.getWarehouses();
			},
			getSearchDef() {
			      return {
			        offset: 12,
			        placeholder: 'please input searchkey'
			        //,
			        //props: ['state', 'flow_type'] // can be string or Array
			      }
			    },
			getWarehouses() {
				var vm = this;
				let para = {
					params:{

						offset: (vm.page-1)*vm.pageSize,
						max: vm.pageSize
					}
				};
				vm.listLoading = true;
				//NProgress.start();
				if(vm.batchNo){
					para.params.batchNo = vm.batchNo
				}
				var uploadName = '';
				for(var i = 0; i <vm.name.length; i++){
					uploadName+= vm.name[i]+','
				}
				para.params.name =uploadName;
				webapi.get('/warehouse', para)
				  .then(function(response) {
            if (response.data=="nopermission") {
              vm.$notify({
                  title: '警告',
                  message: '您的账户已到期,请联系管理员.',
                  type: 'warning'
                });
            }else{
				    vm.total = response.data.total;
				    vm.warehouses = response.data.results;
          }
				    vm.listLoading = false;
				 }).catch((error) => {
					vm.listLoading = false;
				    vm.$message.error(error.response.data['message']);
				});
			},

			selsChange: function (sels) {
				this.sels = sels;
			},
			rowDblclick:function(row, event){
				console.log(row)
			}
		},
		mounted() {
			this.getWarehouses();
			this.remoteMethod('');
		}
	}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// WarehouseTable.vue?0a1a73f6